import React, { useEffect } from 'react';

import { useDetectClickOutsideElement } from '../../../hooks/useDetectClickOutsideElement';

import styles from './styles.module.css';

const Dropdown = ({
	isOpen,
	onClose,
	children,
	className = '',
	contentClassName = '',
	style,
	contentStyle,
	closeOnEsc = true,
	role = 'menu',
	id,
	ariaLabel,
}) => {
	const { containerRef } = useDetectClickOutsideElement({
		onClickOutside: () => {
			if (isOpen && typeof onClose === 'function') onClose();
		},
	});

	useEffect(() => {
		if (!closeOnEsc) return undefined;
		const handleKeyDown = (e) => {
			if (e.key === 'Escape' && isOpen && typeof onClose === 'function') {
				onClose();
			}
		};
		document.addEventListener('keydown', handleKeyDown);
		return () => document.removeEventListener('keydown', handleKeyDown);
	}, [isOpen, onClose, closeOnEsc]);

	return (
		<div
			ref={containerRef}
			className={
				`${styles.dropdown}${isOpen ? ` ${styles.open}` : ''}${className ? ` ${className}` : ''}`
			}
			style={style}
			id={id}
			aria-haspopup="menu"
			aria-expanded={!!isOpen}
			aria-label={ariaLabel}
		>
			{isOpen && (
				<div
					className={`${styles.content} ${contentClassName}`.trim()}
					style={contentStyle}
					role={role}
				>
					{children}
				</div>
			)}
		</div>
	);
};

export default Dropdown;




// WEBPACK FOOTER //
// ./src/components/V2/dropdown/index.jsx